import React, { useEffect } from 'react'
import utils from '../../utils'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { FaStoreAlt } from 'react-icons/fa'
import { RiAdminFill } from "react-icons/ri";

function ProductRow(props) {
    const product = props.product

    useEffect(() => { }, [product])
    return (
        <tr>
            <td className='hidden md:table-cell'>
                <div >
                    <img src={product?.image} alt={product?.name} className='h-16 w-16 rounded-lg hidden md:block object-contain' />
                </div>
            </td>
            <td className='flex gap-3 items-center'>
                <div>
                    <Link
                        className='font-bold hover:underline'
                        to={`/product/${product?.slug}`}>
                        {product?.name}
                    </Link>
                    <div className='text-gray-600'>
                        {product?.store_name ? (
                            <div className='flex gap-2 items-center'>
                                <FaStoreAlt />
                                <div >
                                    {product?.store_name}
                                </div>
                            </div>
                        ) : (
                            <div>
                                {product?.owner && (
                                    <span className='flex gap-2 items-center'>
                                        <RiAdminFill />
                                        {product?.owner?.full_name || product?.owner?.email}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </td>

            <td className='hidden md:table-cell'>
                {product?.brand_name || '-'}
            </td>
            <td className='font-bold'>
                {utils.toCommas(product?.price)}
            </td>

            <td className='font-bold hidden md:table-cell'>
                <span className={product?.quantity < 5 ? 'text-error' : ''}>{product?.quantity}</span>
            </td>
            <td className='hidden md:table-cell'>
                {utils.toCommas(product?.purchases)}
            </td>
            <td className='hidden md:table-cell'>
                {moment(product?.creation_time).format("MMM Do YYYY")}
            </td>
            <td>
                <button
                    onClick={() => props.openModal(1, product)}
                    className='btn btn-sm btn-primary'>View</button>
            </td>
        </tr>
    )
}

export default ProductRow